import { Component, Input } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';

@Component({
  selector: 'app-box',
  templateUrl: './box.component.html',
  styleUrls: ['./box.component.scss'],
  imports: [MatIconModule],
})
export class BoxComponent {
  @Input() count = 0;
  constructor() {}
}
